"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HamuSmartyPages = void 0;
var HamuSmartyPages;
(function (HamuSmartyPages) {
    HamuSmartyPages["HAMU_26_TH"] = "HAMU_26_TH";
    HamuSmartyPages["HOMEPAGE"] = "HOMEPAGE";
    HamuSmartyPages["THE_ROKA"] = "THE_ROKA";
    HamuSmartyPages["SF"] = "SF";
})(HamuSmartyPages || (exports.HamuSmartyPages = HamuSmartyPages = {}));
